import './pos.scss';

import { isString } from 'lodash';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Broadcaster } from '@core/app/scripts/services/broadcaster';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { FocusStream } from '@pos/app/scripts/services/focus-streams';
import { PosSearch } from '@pos/app/scripts/services/pos-search';
import { PosUiState } from '@pos/app/scripts/services/pos-ui-state';
import { SalesCalculations } from '@shared/app/scripts/services/sales-calculations';
import { Utility } from '@core/app/scripts/services/utility';

import { isString } from 'lodash';

/*
 * Component responsible for /pos route.
 */
angular
  .module('posApp')
  .directive(
    'pos',
    (
      $injector: ng.IInjectStatic,
      $timeout: ng.ITimeoutService,
      broadcaster: Broadcaster,
      displayMessage: DisplayMessage,
      focusStreams: FocusStream,
      salesCalculations: SalesCalculations,
      isFiscalReturn,
      isFiscalSale,
      isTest,
      loadCustomerInfo,
      navigateTo: NavigateTo,
      pos,
      posSearch: PosSearch,
      posReasons,
      posUiState: PosUiState,
      translate: ng.translate.ITranslateService,
      utility: Utility,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./pos.html').default,

      link: function ($scope: any) {
        const $translate = translate;

        function selectLastLine() {
          if (pos.transaction?.receipt) {
            posUiState.selectedLine = pos.transaction.receipt.length - 1;
          } else {
            posUiState.selectedLine = -1;
          }
        }

        $scope.pos = pos;
        $scope.posReasons = posReasons;
        $scope.posInit = $injector.get('posInit');
        $scope.isFiscalReturn = isFiscalReturn;
        $scope.isFiscalSale = isFiscalSale;
        $scope.dialog = posUiState.dialog;

        // Hack, meant to disable compiling <customer-card> when we are running
        // unit tests. In v7 we would just test controller, without compiling
        // their template
        $scope.isTest = isTest;

        $scope.posInit.pageRef = 'pos.route#pos';

        $scope.searchFocus$ = focusStreams.search$;

        $timeout(() => {
          focusStreams.searchSubject.next(undefined);
        });

        posUiState.dialog.show = false;
        posUiState.dialog.showReasons = false;
        posUiState.dialog.inputValue = '';
        posUiState.dialogCallback = '';
        posUiState.dialog.reason = '';

        //vars for popups
        $scope.openPayStoreCredit = false;
        $scope.payStoreCreditAmount = 0;

        posUiState.resetDialog();

        pos.returnArticleMode = false;
        focusStreams.searchSubject.next(undefined);
        broadcaster.send('windowResized');

        selectLastLine();

        $scope.search = (searchInput: string) => {
          posUiState.resetDialog();

          $scope.searchInput = '';

          if (isString(searchInput)) {
            posSearch.scan(searchInput.trim()).then(selectLastLine);
          }
        };

        $scope.onChangeCashier = () => {
          pos.onChangeCashier();
        };

        $scope.showCustomerInfo = () => {
          if (
            pos.transaction &&
            pos.transaction.customer &&
            pos.transaction.customer.id
          ) {
            loadCustomerInfo('pos.route#pos');
            navigateTo(
              'pos.route#customer-info/' + pos.transaction.customer.id,
            );
          }
        };

        // get storecredit info
        $scope.toggleStoreCreditPopup = () => {
          $scope.payStoreCreditAmount =
            pos.transaction.customer && pos.transaction.customer.storecredit
              ? pos.transaction.customer.storecredit
              : 0;
          $scope.openPayStoreCredit = $scope.openPayStoreCredit ? false : true;
          broadcaster.send('setFocus', ['payStoreCreditAmount', true]);
        };

        //Add a pay store credit line to the receipt
        $scope.payStoreCredit = (requestPay) => {
          //Check the amount entered to ensure it is not too high
          if (requestPay > pos.transaction.customer.storecredit) {
            displayMessage.message($translate.instant('AmountIsTooHigh'));
            return;
          }

          $scope.openPayStoreCredit = false;
          const reqid = salesCalculations.addTemporaryReceiptLine(
            pos.transaction,
            {
              found: true,
              category: 'storecredit',
              type: 'O',
              price: requestPay,
              qty: 1,
              nettPrice: requestPay,
            },
          );

          pos.transaction.totalAmount = utility.round2(
            pos.transaction.totalAmount + requestPay,
          );
          selectLastLine();

          //Update all totals
          pos.updateTotals();

          //Scroll to the last item
          broadcaster.send('forceScroll');

          pos.activeStorecredit = true;
          $scope.$digest();
          focusStreams.searchSubject.next(undefined);
        };

        /**Split a single line param1[param2] into multiple lines of 1 qty each. Returns the index of the last item.
         * @param {array} receipt
         * @param {int} index position of the line you want to be split
         * @return {int} index position of the last line that's part of the split
         */
        // TODO replace by a service method
        const splitReceiptLine = (receipt, index) => {
          if (receipt.qty !== 0) {
            //negatives to accomedate retours
            const tqty = Math.abs(receipt[index].qty);
            const qty = receipt[index].qty > 0 ? 1 : -1;

            for (let k = 1; k < tqty; k++) {
              const copy = angular.copy(receipt[index]);
              copy.qty = qty;
              delete copy.reqid;
              receipt.splice(index, 0, copy);
              index++;
            }
            receipt[index].qty = qty;
          }
          return index;
        };

        posUiState.multiLine = false;
      },
    }),
  );
